import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@store/create-store';
import { HourlyDataRequest } from '@scenario/models/hourly-data-request.model';

export interface HourlyDataRequestState {
  isSaving: boolean;
  error?: string;
}

const initialState: HourlyDataRequestState = {
  isSaving: false,
};

export const hourlyDataRequestSlice = createSlice({
  name: 'hourly-data-request',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    requestHourlyData: (state, _action: PayloadAction<HourlyDataRequest>) => {
      state.isSaving = true;
      state.error = undefined;
    },
    requestHourlyDataSuccess: state => {
      state.isSaving = false;
    },
    requestHourlyDataFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isSaving = false;
    },
  },
});

export type HourlyDataRequestViewModel = {
  isSaving: boolean;
  error?: string;
};

export const selectHourlyDataRequestViewModel = createSelector(
  (state: RootState) => state,
  (state): HourlyDataRequestViewModel => ({
    isSaving: state.hourlyDataRequest.isSaving,
    error: state.hourlyDataRequest.error,
  }),
);

export const {
  requestHourlyData,
  requestHourlyDataFailure,
  requestHourlyDataSuccess,
} = hourlyDataRequestSlice.actions;

export default hourlyDataRequestSlice.reducer;
